import {createClient} from '@sanity/client'
import clientConfig from '../../client-config';

const client = createClient({
    ...clientConfig.sanity,
    useCdn: false // `false` if you want to ensure fresh data
})

export default client
